import { Box } from '@material-ui/core';
import Circle from '@src/components/Common/Circle';
import CustomAvatar from '@src/components/Common/CustomAvatar';
import IconWrapper from '@src/components/Common/IconWrapper';
import CallRejectedIcon from '@src/resources/icons/CallRejectedIcon';
import { activeChatSelector } from '@src/selectors/chats';
import { CallPermissionResponse } from '@src/types/calls';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const ChatMessageCallPermission: React.FC<{
  permissionResponse: CallPermissionResponse;
}> = ({ permissionResponse }) => {
  const { formatMessage } = useIntl();

  const chat = useSelector(activeChatSelector);

  return (
    <Box className="call-container">
      <Circle size={35} className="call-icon" style={{ overflow: 'hidden' }}>
        <>
          {permissionResponse === CallPermissionResponse.ACCEPTED && (
            <CustomAvatar
              type="invert"
              avatarSrc={chat?.contact?.avatarUrl as string}
              username={chat?.contact?.fullName as string}
            />
          )}

          {permissionResponse === CallPermissionResponse.REJECTED && (
            <IconWrapper fontSize={23}>
              <CallRejectedIcon />
            </IconWrapper>
          )}
        </>
      </Circle>

      <Box className="call-content">
        {permissionResponse === CallPermissionResponse.ACCEPTED &&
          formatMessage({ id: 'CallPermission.Accepted.TitleLbl' })}
        {permissionResponse === CallPermissionResponse.REJECTED &&
          formatMessage({ id: 'CallPermission.Rejected.TitleLbl' })}
        <Box className="call-content-descripton">
          {permissionResponse === CallPermissionResponse.ACCEPTED &&
            formatMessage({ id: 'CallPermission.Accepted.ContentLbl' })}
          {permissionResponse === CallPermissionResponse.REJECTED &&
            formatMessage({ id: 'CallPermission.Rejected.ContentLbl' })}
        </Box>
      </Box>
    </Box>
  );
};

export default ChatMessageCallPermission;
